import {
  COOKIE_AUTH_ENABLED,
  hasCookieAuthSignal,
} from "@/core/generated/api/auth_cookies"

export const AUTH_KEY = "_ft_a_"
export const POST_LOGIN_REDIRECT_KEY = "_ft_post_login_redirect_"

const isBrowser = (): boolean => typeof window !== "undefined"

// const setItem = (key: string, value: string): void => {
//   if (!isBrowser() || key !== AUTH_KEY || !value) return
//   window.sessionStorage.setItem(AUTH_KEY, value)
// }

// const getItem = (key: string): string | null => {
//   if (!isBrowser()) return null
//   if (key !== AUTH_KEY) return null

//   const value = window.sessionStorage.getItem(AUTH_KEY)
//   return value && value.length > 0 ? value : null
// }

// const removeItem = (key: string): void => {
//   if (!isBrowser()) return
//   if (key !== AUTH_KEY) return

//   window.sessionStorage.removeItem(AUTH_KEY)
// }

const setItem = (key: string, value: string): void => {
  if (!isBrowser() || key !== AUTH_KEY || !value) return
  if (COOKIE_AUTH_ENABLED) return
  window.sessionStorage.setItem(AUTH_KEY, value)
}
const getItem = (key: string): string | null => {
  if (!isBrowser()) return null
  if (key !== AUTH_KEY) return null
  if (COOKIE_AUTH_ENABLED) return null

  const value = window.sessionStorage.getItem(AUTH_KEY)
  return value && value.length > 0 ? value : null
}
const removeItem = (key: string): void => {
  if (!isBrowser()) return
  if (key !== AUTH_KEY) return
  if (COOKIE_AUTH_ENABLED) return

  window.sessionStorage.removeItem(AUTH_KEY)
}

const getSafeRedirectUrl = (value?: string | null): string => {
  if (!value) return "/"
  if (typeof value !== "string") return "/"

  const v = value.trim()
  if (v.length === 0) return "/"
  if (!v.startsWith("/")) return "/"
  if (v.startsWith("//")) return "/"
  return v
}

const getFirstRedirectUrl = (
  ...values: Array<string | null | undefined>
): string => {
  for (const value of values) {
    const safe = getSafeRedirectUrl(value)
    if (safe !== "/") return safe
  }

  return "/"
}

const getReturnUrlFromToken = (token?: string | null): string | null => {
  if (!isBrowser() || !token) return null

  const payload = token.split(".")[1]
  if (!payload) return null

  try {
    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/")
    const padding = (4 - (base64.length % 4)) % 4
    const padded = base64 + "=".repeat(padding)
    const parsed = JSON.parse(window.atob(padded)) as Record<string, unknown>

    return typeof parsed.returnUrl === "string" ? parsed.returnUrl : null
  } catch {
    return null
  }
}

const setPostLoginRedirect = (url: string): void => {
  if (!isBrowser()) return
  const safe = getSafeRedirectUrl(url)
  window.sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, safe)
}

const getPostLoginRedirect = (): string | null => {
  if (!isBrowser()) return null
  const value = window.sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY)
  const safe = getSafeRedirectUrl(value)
  return safe === "/" ? null : safe
}

const clearPostLoginRedirect = (): void => {
  if (!isBrowser()) return
  window.sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY)
}

// const isAuthenticated = (): boolean => {
//   const token = getItem(AUTH_KEY)
//   return typeof token === "string" && token.length > 0
// }
const isAuthenticated = (): boolean => {
  if (COOKIE_AUTH_ENABLED) return hasCookieAuthSignal()

  const token = getItem(AUTH_KEY)
  return typeof token === "string" && token.length > 0
}

const buildCurrentAppUrl = (): string => {
  if (!isBrowser()) return "/"
  return (
    window.location.pathname + window.location.search + window.location.hash
  )
}

// const requireAuth = (): boolean => {
//   if (!isBrowser()) return false
//   if (isAuthenticated()) return true

//   // During auth callbacks we may temporarily be unauthenticated until the app
//   // stores the token from the query string (e.g. `?_ft_c=...`). Avoid redirect
//   // loops in that window.
//   const params = new URLSearchParams(window.location.search)
//   if (params.has("_ft_c")) return false

//   const currentUrl = buildCurrentAppUrl()
//   setPostLoginRedirect(currentUrl)

//   const redirectParam = encodeURIComponent(currentUrl)
//   console.log("redirectParam", redirectParam)
//   window.location.assign(`/login?returnUrl=${redirectParam}`)
//   return false
// }
const requireAuth = ({
  ignoreExistingAuth = false,
}: {
  ignoreExistingAuth?: boolean
} = {}): boolean => {
  if (!isBrowser()) return false
  if (!ignoreExistingAuth && isAuthenticated()) return true

  // During auth callbacks we may temporarily be unauthenticated until the app
  // stores the token from the query string (e.g. `?_ft_c=...`). Avoid redirect
  // loops in that window.
  const params = new URLSearchParams(window.location.search)
  if (params.has("_ft_c")) return false

  // const currentUrl = buildCurrentAppUrl()
  const currentUrl = getCurrentReturnUrl()
  setPostLoginRedirect(currentUrl)

  const redirectParam = encodeURIComponent(currentUrl)
  console.log("redirectParam", redirectParam)
  window.location.assign(`/login?returnUrl=${redirectParam}`)
  return false
}

const handleLoginSuccessRedirect = (token?: string | null): void => {
  if (!isBrowser()) return

  const params = new URLSearchParams(window.location.search)
  const finalRedirect = getFirstRedirectUrl(
    params.get("returnUrl"),
    getReturnUrlFromToken(token),
    getPostLoginRedirect(),
  )

  clearPostLoginRedirect()
  window.location.assign(finalRedirect)
}

const logout = (): void => {
  if (!isBrowser()) return
  removeItem(AUTH_KEY)
  clearPostLoginRedirect()
  window.location.assign("/login")
}

const getCurrentReturnUrl = (): string => {
  const currentUrl = buildCurrentAppUrl()

  if (window.location.pathname !== "/login") {
    return currentUrl
  }

  const params = new URLSearchParams(window.location.search)
  return getSafeRedirectUrl(params.get("returnUrl"))
}

export {
  isBrowser,
  setItem,
  getItem,
  removeItem,
  isAuthenticated,
  requireAuth,
  handleLoginSuccessRedirect,
  logout,
  getSafeRedirectUrl,
  getFirstRedirectUrl,
  getReturnUrlFromToken,
  setPostLoginRedirect,
  getPostLoginRedirect,
  clearPostLoginRedirect,
}
